(function () {
  /* ----------------------------------------------------------------
     IB-600: feedback carrello (toast in alto a destra).
     - Rimozione dal carrello (item 11): toast "Prodotto rimosso dal
       carrello" su `on:line-item:change` con newQuantity 0.
     Il toast di aggiunta al carrello e' stato rimosso su richiesta.
     Riusa lo stile dei toast wishlist (.wishlist-toast*) gia' caricato in PDP,
     col bottone di chiusura e auto-dismiss breve.
  ---------------------------------------------------------------- */
  var TOAST_TIMEOUT = null;

  function getToastRoot() {
    var root = document.querySelector('.wishlist-toast-region');
    if (root) return root;
    root = document.createElement('div');
    root.className = 'wishlist-toast-region';
    root.setAttribute('role', 'status');
    root.setAttribute('aria-live', 'polite');
    document.body.appendChild(root);
    return root;
  }

  function showToast(msg, added) {
    var root = getToastRoot();
    var el = document.createElement('div');
    el.className = 'wishlist-toast wishlist-toast--' + (added ? 'added' : 'removed');
    el.innerHTML =
      '<span class="wishlist-toast__icon" aria-hidden="true">' +
      (added ? '&#10003;' : '&#10005;') +
      '</span><span class="wishlist-toast__text"></span>' +
      '<button type="button" class="wishlist-toast__close" aria-label="Chiudi">&#10005;</button>';
    el.querySelector('.wishlist-toast__text').textContent = msg;
    root.appendChild(el);

    void el.offsetWidth;
    el.classList.add('is-visible');

    function dismiss() {
      if (TOAST_TIMEOUT) clearTimeout(TOAST_TIMEOUT);
      TOAST_TIMEOUT = null;
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    }

    el.querySelector('.wishlist-toast__close').addEventListener('click', dismiss);

    if (TOAST_TIMEOUT) clearTimeout(TOAST_TIMEOUT);
    TOAST_TIMEOUT = setTimeout(dismiss, 1800);
  }

  // Variazione di una riga gia' presente: mostra il toast solo in rimozione
  // (item 11). L'aggiunta non genera piu' alcun toast.
  document.addEventListener('on:line-item:change', function (evt) {
    if (!evt || !evt.detail) return;
    var newQ = Number(evt.detail.newQuantity);
    if (newQ === 0) {
      showToast('Prodotto rimosso dal carrello', false);
    }
  });
})();
